import { ColumnType } from 'antd/es/table';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import { phaseApis } from "../../api/Phase";
import dayjs from "dayjs";
import { TooltipComponent } from "../../components/Component";
import { tasksApis } from '../../api/NewTasks';

const TaskWiseTimeLogs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [ownerFilterData, setOwnerFilterData] = useState([]);
  const { id: projectId, projectName } = location.state || {};

  const columns: ColumnType<any>[] = [
    {
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
      width: 150,
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`task-${record?.taskId}`}
              onClick={() => {
                console.log("Task Name Clicked:");
                navigate(`/pms/project/task-detail/${record.taskId}`, {
                  state: {
                    projectId,
                    projectName,
                    returnPath: location.pathname,
                    returnState: location.state,
                  },
                });
              }}
            >
              {text}
            </span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon={""}
              id={`task-${record?.taskId}`}
              direction="right"
              text={"Click To View " + text + " Details"}
              containerClassName={"mt-1"}
            />
          </>
        );
      },
    },
    {
      title: "User",
      dataIndex: "userName",
      key: "userName",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      width: 150,
      render: (text: string) => text || "N/A"
    },
    {
      title: "Planned Hours",
      dataIndex: "plannedHours",
      key: "plannedHours",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Hrs`)
    },
    {
      title: "Hours Logged",
      dataIndex: "hoursLogged",
      key: "hoursLogged",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Hrs`)
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
  ];


  const fetchOwnerFilterData = async () => {
    try {
      const response = await tasksApis.getOwnersFilterData(
        projectId?.toString()
      );
      const { data, status } = response || {};
      if (status) {
        const options = data.map((item: any) => {
          return {
            label: item.userName,
            value: item.userId,
          };
        });
        setOwnerFilterData(options);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };


  useEffect(() => {
    fetchOwnerFilterData();
    dispatch(
      updateMenuData([
        {
                    text: "Task-Wise Time Logs",
                    link: "pms/task-wise-timelogs",
                },
                {
                    text: "Activity-Wise Time Logs",
                    link: "pms/activity-wise-timelogs",
                },
                {
                    text: "Phase-Wise Time Logs",
                    link: "pms/phase-wise-timelogs",
                },
      ])
    );
  }, []);

  return (
    <>
      <Template1
        moduleKey={window.location.pathname}
        columns={columns}
        pageTitle='TaskWIse Timelog Report'
        pageDescription=''
        previousPath={{
          link: "/pms/project/reports",
          state: location.state,
        }}
        filters={{
          defaultFilters: {
            dateRange: {
              title: "Task Actual Start Date",
            },
          },
          customFilters: [
            {
              type: "multiple_selection",
              name: "UserId",
              label: "Users",
              options: ownerFilterData,
            },
          ]
        }}
      />
    </>
  )
};

export default TaskWiseTimeLogs;